import { memo, useEffect } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux'
import { IconButton, Menu, MenuButton, MenuItem, MenuList, Portal, useToast } from '@chakra-ui/react'

import config from "../../../../config/app-config";
import { redirectToNewPage, triggerLaunchdeckToast } from '../../../global/helpers/global-helpers';
import { CgOptions } from "react-icons/cg";
import { displayReactIcon } from '../../../digital-sales-room/helpers/dsr-display-helpers';
import { updateDsr } from '../../../digital-sales-room/actions/dsr-actions';

function DsrCardOptionsButton({ 
  dsrId, 
  isDsrAdmin,
  dsrTitle, 
  dsrStatus,
  createDuplicateDsrOutcome, 
  isMobileView,
  handleChangeUserActionRequired,
  updateDsr
}) {

  const toast = useToast();
  const { displayUrl } = config;


  useEffect(() => {
    if (createDuplicateDsrOutcome) {
      const { dsrSuccessfullyDuplicated, createdDsrPath } = createDuplicateDsrOutcome || {};

      if (dsrSuccessfullyDuplicated === true && createdDsrPath) {
        const redirectUrl = `${displayUrl}${createdDsrPath}`
        redirectToNewPage(redirectUrl)
      }
    }

  }, [createDuplicateDsrOutcome, displayUrl])


  const copyLink = () => {
    // Copy into clipboard
    const shareLink = (dsrStatus === "active") ? `${displayUrl}/dsr/access/${dsrId}` 
        : (dsrStatus === "draft" || dsrStatus === "reverted-draft") ? `${displayUrl}/draft/${dsrId}`
        : ""

    shareLink && navigator.clipboard.writeText(shareLink)

    toast(
      triggerLaunchdeckToast({
        label: "Link copied",
        isMobileView
      })
    )
  }

  const duplicateDsr = () => {
    handleChangeUserActionRequired("duplicate-dsr", {
      dsrIdToDuplicate: dsrId,
      dsrTitle
    })
  }

  const makeDsrTemplate = () => {
    handleChangeUserActionRequired("make-dsr-template", {
      sourceDsrId: dsrId,
      dsrTitle
    })
  }

  const changeRoomStatus = (userAction) => {
    let userActionRequired = "";
    let modalTransferPayload = ""
    switch(userAction) {
      case("unpublish-dsr-card"): {
        userActionRequired = "unpublish-dsr-card"
        modalTransferPayload = {
          dsrId: dsrId,
          dsrTitle: dsrTitle
        }
        break
      }
      case("publish-dsr-card"): {
        userActionRequired = "publish-dsr-card"
        modalTransferPayload = {
          dsrId: dsrId,
          dsrTitle: dsrTitle,
          dsrStatus
        }
        break
      }
      default: {
        break;
      }
    }

    userActionRequired && handleChangeUserActionRequired(userActionRequired, modalTransferPayload)
  }

  const archiveRoom = () => {
    if (dsrId && isDsrAdmin) {
      updateDsr({ 
        dsrId, 
        status: 'archived', 
        sourceEvent:"archive-dsr" 
      })
    }
  }

  return (
    <>
      <Menu isLazy placement="bottom-end">
        <MenuButton
          as={IconButton}
          aria-label='Options'
          icon={<CgOptions />}
          variant='outline'
          size='2em'
          p='0.25em'
        />
        <Portal>
        <MenuList px='0.5em' fontSize='0.875em'>
          {(dsrStatus === "active")  && <MenuItem name='copy-link-option' className='filter-menu__dropdown-option-display' onClick={() => copyLink()} >{displayReactIcon("link","1.5em") }Copy share link</MenuItem>}
          <MenuItem name='duplicate-dsr-option' className='filter-menu__dropdown-option-display' onClick={() => duplicateDsr()}  >{displayReactIcon("copy","1.5em") }Duplicate Room</MenuItem>
          <MenuItem name='make-template-option' className='filter-menu__dropdown-option-display' onClick={() => makeDsrTemplate()}>{displayReactIcon("template","1.5em") }Make template</MenuItem>
          {(dsrStatus === "active" && isDsrAdmin) && <MenuItem name='archive-room' className='filter-menu__dropdown-option-display' onClick={() => archiveRoom()}>{displayReactIcon("archive","1.5em") } Archive Room</MenuItem>} 
          {(dsrStatus === "active" && isDsrAdmin) && <MenuItem name='unpublish-room' className='filter-menu__dropdown-option-display' onClick={() => changeRoomStatus('unpublish-dsr-card')}>{displayReactIcon("undo","1.5em") } Unpublish Room</MenuItem>}
          {(dsrStatus === "reverted-draft" && isDsrAdmin) && <MenuItem name='re-publish-room' className='filter-menu__dropdown-option-display' onClick={() => changeRoomStatus('publish-dsr-card')}>{displayReactIcon("check","1.5em") } Republish Room</MenuItem>}
        </MenuList>
        </Portal>
      </Menu>
    </>
  );

}


const mapStateToProps = state => ({
  createDuplicateDsrOutcome: state.createDuplicateDsrOutcome.results.data, 
  isMobileView: state.mobileViewMode.isMobileView
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDsr
    },
    dispatch,
  )


export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrCardOptionsButton)))